import gql from 'graphql-tag';

export default gql`
    mutation EditBox($input: EditBoxInput) {
        editBox(input: $input) {
            errors
        }
    }
`;
